<template>
  <div class="benefit-wrap">
    <header>
      <span class="title">{{ t('promo.vip.benefit.title') }}</span>
      <span class="hint">{{ t('promo.vip.benefit.hint', { total: totalLevels }) }}</span>
    </header>
    <section class="benefit-table">
      <table class="lvl-table">
        <thead>
          <tr>
            <th>{{ t('promo.vip.benefit.level') }}</th>
            <th>{{ t('promo.vip.benefit.totalDeposit') }}</th>
            <th>{{ t('promo.vip.benefit.upgradeBonus') }}</th>
            <th>{{ t('promo.vip.benefit.dailyBonus') }}</th>
            <th>{{ t('promo.vip.benefit.weeklyBonus') }}</th>
            <th>{{ t('promo.vip.benefit.monthlyBonus') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.level" :class="{ on: row.level === currentLevel }">
            <td class="level">V{{ row.level }}<span v-if="row.level === currentLevel"> ←</span></td>
            <td>{{ fmt(row.threshold) }}</td>
            <td class="gold">{{ fmt(row.upgrade_amount) }}</td>
            <td>{{ fmt(row.daily_amount) }}</td>
            <td>{{ fmt(row.weekly_amount) }}</td>
            <td>{{ fmt(row.monthly_amount) }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script setup lang="ts">
import { formatBaseAmt } from '~/utils/transfer/money'
import type { VipLevelBenefit } from '../types'

defineProps<{ rows: VipLevelBenefit[]; totalLevels: number; currentLevel?: number }>()

const { t } = useI18n()
const userStore = useUserStore()
const fmt = (n: number) => formatBaseAmt(n, userStore.baseCurrency)
</script>

<style scoped lang="scss">
.benefit-table {
  overflow-x: auto;
  border: 1px solid var(--hairline);
  border-radius: 14px;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  scrollbar-width: none;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 18px;
}

.title {
  font-size: 16px;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 7px;
}

.hint {
  font-size: 12px;
  color: var(--muted);
}

th {
  background: var(--surface2);
  color: var(--muted);
  font-weight: 700;
  padding: 10px 12px;
  text-align: right;
}

.lvl-table th:first-child {
  text-align: left;
}

.lvl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  white-space: nowrap;
}

td {
  padding: 11px 12px;
  text-align: right;
  border-top: 1px solid var(--hairline);
}

.lvl-table td:first-child {
  text-align: left;
  font-weight: 800;
}

td.level {
  font-weight: 800;
}

td.gold {
  color: var(--gold-fg);
  font-weight: 800;
}

tbody tr:last-child td {
  border-bottom: 0;
}

tbody tr.on {
  background: rgba(var(--primary-rgb), 0.14);
}

tbody tr.on td.level {
  color: var(--primary);
}
</style>
